"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var ListModel_1 = require("@twii/core/lib/model/ListModel");
var ListingServiceContext_1 = require("../service/ListingServiceContext");
var StringUtils_1 = require("@twii/core/lib/StringUtils");
var ListingListModel = /** @class */ (function (_super) {
    __extends(ListingListModel, _super);
    function ListingListModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._searchDelay = 500;
        _this._refreshDone = function (res) {
            delete _this._searchTimeout;
            _this._counts = res.counts;
            _this.setItems(res.listings);
        };
        _this._refreshError = function (error) {
            _this.clearItems();
            _this.sync.syncError(error);
        };
        _this._searchImpl = function () {
            var search = _this.searchText;
            var request;
            if (StringUtils_1.isNotBlank(search)) {
                request = {
                    search: search
                };
            }
            return _this.listingService.getListings(request).then(function (results) {
                if (search === _this.searchText) {
                    _this._refreshDone(results);
                }
            }).catch(function (error) {
                if (search === _this.searchText) {
                    _this._refreshError(error);
                }
            });
        };
        return _this;
    }
    Object.defineProperty(ListingListModel.prototype, "listingService", {
        get: function () {
            return this._listingService || ListingServiceContext_1.ListingServiceContext.value;
        },
        set: function (value) {
            this._listingService = value;
        },
        enumerable: true,
        configurable: true
    });
    ListingListModel.prototype.setSearchText = function (searchText) {
        if (searchText !== this.searchText) {
            this.searchText = searchText;
            if (this._searchTimeout) {
                clearTimeout(this._searchTimeout);
            }
            this.sync.syncStart();
            this._searchTimeout = setTimeout(this._searchImpl, this._searchDelay);
        }
    };
    Object.defineProperty(ListingListModel.prototype, "counts", {
        get: function () {
            return Object.assign({}, this._counts);
        },
        enumerable: true,
        configurable: true
    });
    ListingListModel.prototype.refresh = function () {
        this.sync.syncStart();
        return this._searchImpl();
    };
    __decorate([
        mobx_1.observable
    ], ListingListModel.prototype, "searchText", void 0);
    __decorate([
        mobx_1.observable
    ], ListingListModel.prototype, "_counts", void 0);
    __decorate([
        mobx_1.action
    ], ListingListModel.prototype, "setSearchText", null);
    __decorate([
        mobx_1.computed
    ], ListingListModel.prototype, "counts", null);
    __decorate([
        mobx_1.action
    ], ListingListModel.prototype, "_refreshDone", void 0);
    __decorate([
        mobx_1.action
    ], ListingListModel.prototype, "_refreshError", void 0);
    __decorate([
        mobx_1.action
    ], ListingListModel.prototype, "_searchImpl", void 0);
    __decorate([
        mobx_1.action
    ], ListingListModel.prototype, "refresh", null);
    return ListingListModel;
}(ListModel_1.ListModel));
exports.default = ListingListModel;
exports.ListingListModel = ListingListModel;
